/* HTK — the LIVE haydartekeli.com page script, ported to Shopify (2026-09-11).
   Kept from live: WhatsApp link wiring · burger menu · Kendini Yokla counter + sticky bar ·
   header focus mode · CTA counters · WhatsApp bubble.
   Changed for Shopify: the ön bakım list is stored for the checkout (assets/hst.js puts it on the
   order), the WhatsApp link carries the ticked symptoms, the ACİL bar height drives the sticky
   header, the language pill opens on tap, and the CURRENCY FOLLOWS LOCATION. */
(function () {
  'use strict';
  /* Preserve the ad door and draft preview across locale/country form submits. */
  var localeForm = document.getElementById('HtkLangForm');
  if (localeForm) {
    var returnTo = localeForm.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  }
  var WA_NUMBER = "905398805109";
  var MSGS = {
    genel: "Esselamu Aleyküm Hocam, danışmanlık için yazıyorum.",
    acil: "Esselamu Aleyküm Hocam, acil yardıma ihtiyacım var.",
    egitim: "Esselamu Aleyküm Hocam, metafizik ve havass eğitimi için yazıyorum.",
    belirti: "Esselamu Aleyküm Hocam, sitedeki belirtilerden bende olanlar var, durumumu anlatmak istiyorum.",
    gurbet: "Esselamu Aleyküm Hocam, Avrupa'dan yazıyorum, danışmak istiyorum."
  };
  function waUrl(text) { return "https://wa.me/" + WA_NUMBER + "?text=" + encodeURIComponent(text); }
  document.querySelectorAll('.htk .walink').forEach(function (el) {
    el.href = waUrl(MSGS[el.dataset.msg] || MSGS.genel);
    el.target = "_blank"; el.rel = "noopener";
  });

  /* sticky header: the ACİL bar scrolls away, the header stays */
  function acil() {
    var a = document.querySelector('.htk .acil');
    if (a) document.documentElement.style.setProperty('--htk-acil-h', a.offsetHeight + 'px');
  }
  acil(); window.addEventListener('resize', acil);

  /* mobile menu */
  var burger = document.getElementById('burger'), menu = document.getElementById('menu');
  if (burger && menu) {
    burger.setAttribute('aria-controls', menu.id);
    function menuState(open) {
      menu.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    menuState(false);
    burger.addEventListener('click', function () { menuState(!menu.classList.contains('open')); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { menuState(false); }); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('open')) { menuState(false); burger.focus(); }
    });
    document.addEventListener('click', function (event) {
      if (!menu.contains(event.target) && !burger.contains(event.target)) menuState(false);
    });
  }

  /* language pill: tap opens on touch screens (hover handles mouse, in CSS) */
  document.querySelectorAll('[data-htk-lang]').forEach(function (box) {
    var pill = box.querySelector('.lang-pill');
    if (!pill) return;
    function languageState(open) { box.classList.toggle('open', open); pill.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    languageState(false);
    pill.addEventListener('click', function (e) { e.stopPropagation(); languageState(!box.classList.contains('open')); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) languageState(false); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { languageState(false); pill.focus(); } });
  });

  /* Kendini Yokla */
  var ycount = document.getElementById('ycount'), ymsg = document.getElementById('ymsg'), ywa = document.getElementById('ycta-wa');
  var ybar = document.getElementById('ybar'), ybarcount = document.getElementById('ybarcount');
  var items = document.querySelectorAll('.htk .yi');
  if (items.length && ycount) {
    var total = items.length;
    ['ytotal', 'ybartotal'].forEach(function (id) { var e = document.getElementById(id); if (e) e.textContent = total; });
    var saved = null;
    if (window.HSTC) saved = window.HSTC.read();
    else try { saved = JSON.parse(sessionStorage.getItem('hst_onbakim') || 'null'); } catch (e) {}
    function label(el) { return el.textContent.replace(/\s+/g, ' ').trim(); }
    var labels = Array.prototype.map.call(items, label);
    /* The upstream questionnaire can use different wording. Never erase its unmatched items. */
    var carried = saved && Array.isArray(saved.items) ? saved.items.filter(function (item) { return labels.indexOf(item) < 0; }) : [];
    items.forEach(function (el) {
      var selected = saved && Array.isArray(saved.items) && saved.items.indexOf(label(el)) > -1;
      el.classList.toggle('on', !!selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    var yUpdate = function () {
      var sel = carried.slice();
      items.forEach(function (el) { if (el.classList.contains('on')) sel.push(label(el)); });
      if (window.HSTC) sel = window.HSTC.save(sel).items;
      items.forEach(function (el) {
        var selected = sel.indexOf(label(el)) >= 0;
        el.classList.toggle('on', selected);
        el.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var yc = sel.length;
      ycount.textContent = yc; if (ybarcount) ybarcount.textContent = yc;
      if (ymsg) ymsg.textContent = yc === 0 ? "Görüşmede anlatmak istediklerini işaretle." : "İşaretlediklerin görüşmede anlatmak istediğin konulara eklenir.";
      /* hst.js reads this and attaches it to the order as "Ön Bakım" */
      if (!window.HSTC) try { sessionStorage.setItem('hst_onbakim', JSON.stringify({ items: sel, total: total })); } catch (e) {}
      if (ywa) ywa.href = waUrl(yc > 0
        ? "Esselamu Aleyküm Hocam, şu belirtiler bende var: " + sel.join('; ') + ". Toplam " + yc + " belirti. Durumumu anlatmak istiyorum."
        : MSGS.belirti);
    };
    items.forEach(function (el) { el.addEventListener('click', function () { el.classList.toggle('on'); yUpdate(); }); });
    yUpdate();
  }

  /* Ön Bakım sticky bar + header focus mode (live logic) */
  (function () {
    var sec = document.getElementById('bakim'), res = document.querySelector('.htk .yres');
    if (!sec || !res || !ybar) return;
    function sync() {
      var sectionRect = sec.getBoundingClientRect(), resultRect = res.getBoundingClientRect();
      var inSection = sectionRect.top < window.innerHeight * 0.75 && sectionRect.bottom > 0;
      var resVisible = resultRect.top < window.innerHeight - 90 && resultRect.bottom > 0;
      var on = inSection && !resVisible;
      document.documentElement.style.setProperty('--ybar-h', ybar.offsetHeight + 'px');
      ybar.classList.toggle('is-on', on);
      document.body.classList.toggle('ybar-on', on);
      if (window.HSTC) window.HSTC.interactive(ybar, on);
      else { ybar.setAttribute('aria-hidden', on ? 'false' : 'true'); ybar.toggleAttribute('inert', !on); }
      document.body.classList.toggle('bakim-focus', inSection);
    }
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule);
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(schedule);
      observer.observe(sec); observer.observe(res);
    }
    sync();
  })();

  /* CTA usage counters (live) */
  document.querySelectorAll('.htk .walink, .htk [data-hst-buy]').forEach(function (el) {
    el.addEventListener('click', function () {
      var sec = el.closest('section,header,footer,.hero,.acil,.son,.wa-bubble') || {};
      var id = (el.dataset.msg || (el.hasAttribute('data-hst-buy') ? 'buy' : '')) + '@' + (el.id || sec.id || (sec.className || '').split(' ')[0] || 'page');
      try { var k = 'cta:' + id; localStorage.setItem(k, (parseInt(localStorage.getItem(k) || '0', 10) + 1)); } catch (err) {}
    });
  });

  /* WhatsApp bubble (live spec) */
  var bubble = document.getElementById('wa-bubble'), waFloat = document.getElementById('wa-float');
  if (bubble && waFloat) {
    var waReady = !!sessionStorage.getItem('wa-seen');
    var showB = function () { bubble.classList.add('is-visible'); };
    var hideB = function () { bubble.classList.remove('is-visible'); };
    setTimeout(function () {
      waReady = true; try { sessionStorage.setItem('wa-seen', '1'); } catch (e) {}
      showB(); setTimeout(function () { showB(); setInterval(showB, 120000); }, 60000);
    }, waReady ? 0 : 7000);
    waFloat.addEventListener('mouseenter', function () { if (waReady && window.matchMedia('(hover: hover)').matches) showB(); });
    bubble.addEventListener('click', function (e) { if (e.target.id === 'wa-close') return; window.open(waFloat.href, '_blank'); });
    var wc = document.getElementById('wa-close');
    if (wc) wc.addEventListener('click', function (e) { e.stopPropagation(); hideB(); });
  }

  /* CURRENCY FOLLOWS LOCATION (Chairman 2026-09-11: "we charge try, usd, euro according to where
     they are"). Shopify remembers a country chosen earlier in a cookie; if that no longer matches
     where the visitor actually is, switch the store back to the detected country once per session.
     The language is never touched. */
  (function () {
    var form = document.getElementById('HtkLangForm');
    var current = document.documentElement.getAttribute('data-htk-country');
    if (!form || !current || !window.fetch) return;
    try { if (sessionStorage.getItem('htk-geo-checked')) return; sessionStorage.setItem('htk-geo-checked', '1'); } catch (e) { return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var det = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!det || det.toUpperCase() === current.toUpperCase()) return;
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'country_code'; i.value = det.toUpperCase();
        form.appendChild(i);
        var lang = document.createElement('input'); lang.type = 'hidden'; lang.name = 'language_code';
        lang.value = document.documentElement.lang || 'tr';
        form.appendChild(lang);
        form.submit();
      })
      .catch(function () {});
  })();
})();
